import React from 'react'
import {
  Card,
  CardActions,
  CardText,
  CardTitle
} from 'material-ui-legacy/Card'
import Row from 'muicss/lib/react/row'
import Col from 'muicss/lib/react/col'

import ValidatedTextInput from '../UI/ValidatedTextInput'
import SaveButton from '../UI/SaveButton'
import CancelButton from '../UI/CancelButton'

/*
Props:
- client: a complete client object
  or
- Client fields: will be inserted in the form when present
- submitCallback: callback function called on form submission. This is *only*
  called when the form is valid and the contents have changed. Receives client
  attributes.
- cancelCallback: callback function for the cancel button.
- changedCallback: callback function called when the form contents have changed.
  Receives true if the contents have changed.
- forceChanged: force the form status to "changed"
*/
class ClientForm extends React.PureComponent {
  constructor(props) {
    super(props)
    // We have to build the state on a regular variable so
    // React doesn't complain about direct state mutation.
    let initialState = {
      formValid: false,
      formChanged: (this.props.forceChanged || false),
      formSubmitted: false
    }

    // We can either receive a single data prop or each field separately
    this.initialData =
      (this.props.client) ? this.props.client.attributes : this.props

    this.fields = [
      'code',
      'name',
      'phone',
      'address',
      'city',
      'province',
      'country',
      'postalCode'
    ]
    for (let field of this.fields) {
      initialState[field] = {
        value: (this.initialData[field] || ''),
        valid: true
      }
    }
    this.state = initialState // Et voilà!
  }

  componentDidMount() {
    if (this.props.forceChanged) this._validateForm()
  }

  _submit = () => {
    // Don't do anything if we have invalid fields or no changes.
    if (!this.state.formValid || !this.state.formChanged) return

    let attributes = {}
    for (let field of this.fields) {
      attributes[field] = this.state[field].value
    }
    this.props.submitCallback(attributes)
    this.setState({formChanged: false, formSubmitted: true})
  }

  _change = (value, valid, attribute) => {
    let updates = {}
    updates[attribute] = {value: value, valid: valid}
    this.setState(
      updates,
      () => {
        this._checkForChanges()
        this._validateForm()
      }
    )
  }

  _checkForChanges = () => {
    let changed = (this.props.forceChanged || false)
    for (let field of this.fields) {
      let current = this.state[field].value
      let original = this.initialData[field] || ''
      if (current !== original) {
        changed = true
        break
      }
    }
    this.setState(
      {formChanged: changed},
      () => {
        if (this.props.changedCallback) {
          this.props.changedCallback(this.state.formChanged)
        }
      }
    )
  }

  _validateForm = () => {
    let allValid = true
    for (let field of this.fields) {
      if (!this.state[field].valid) {
        allValid = false
        break
      }
    }
    this.setState({formValid: allValid})
  }

  render() {
    return (
      <Card>
        {this.props.formTitle && <CardTitle title={this.props.formTitle} />}
        <CardText>
          <Row>
            <Col lg="4" md="12">
              <ValidatedTextInput
                name="name"
                required={true}
                errorMessage="Name is required"
                hintText="Client name"
                floatingLabelText="Name (required)"
                fullWidth={true}
                value={this.state.name.value}
                validatedOnChange={this._change}
              />
            </Col>
            <Col lg="4" md="12">
              <ValidatedTextInput
                name="phone"
                hintText="647-555-5678"
                floatingLabelText="Phone"
                fullWidth={true}
                value={this.state.phone.value}
                validatedOnChange={this._change}
              />
            </Col>
            <Col lg="4" md="12">
              <ValidatedTextInput
                name="address"
                hintText="123 Street Rd."
                floatingLabelText="Street address"
                fullWidth={true}
                value={this.state.address.value}
                validatedOnChange={this._change}
              />
            </Col>
          </Row>
          <Row>
            <Col lg="4" md="12">
              <ValidatedTextInput
                name="city"
                hintText="Townsville"
                floatingLabelText="City"
                fullWidth={true}
                value={this.state.city.value}
                validatedOnChange={this._change}
              />
            </Col>
            <Col lg="4" md="12">
              <ValidatedTextInput
                name="province"
                hintText="ON"
                floatingLabelText="State/Province"
                pattern={/[a-zA-Z]{2}/}
                maxLength={2}
                errorMessage="Invalid state/province code"
                fullWidth={true}
                value={this.state.province.value}
                validatedOnChange={this._change}
              />
            </Col>
            <Col lg="4" md="12">
              <ValidatedTextInput
                name="country"
                hintText="Canada"
                floatingLabelText="Country"
                fullWidth={true}
                value={this.state.country.value}
                validatedOnChange={this._change}
              />
            </Col>
          </Row>
          <Row>
            <Col lg="4" md="12">
              <ValidatedTextInput
                name="postalCode"
                hintText="A1B 2C3"
                floatingLabelText="Postal code"
                fullWidth={true}
                value={this.state.postalCode.value}
                validatedOnChange={this._change}
              />
            </Col>
            <Col lg="4" md="12">
              <ValidatedTextInput
                name="code"
                hintText="c0d3"
                floatingLabelText="Legacy code"
                fullWidth={true}
                value={this.state.code.value}
                validatedOnChange={this._change}
              />
            </Col>
          </Row>
        </CardText>

        <CardActions style={{textAlign: 'center'}}>
          {this.props.submitCallback &&
            <SaveButton
              type="submit"
              disabled={!this.state.formChanged || !this.state.formValid}
              onTouchTap={this._submit}
            />
          }
          {this.props.cancelCallback &&
            <CancelButton
              onTouchTap={this.props.cancelCallback}
              disabled={!this.state.formChanged && this.state.formSubmitted}
            />
          }
        </CardActions>
      </Card>
    )
  }
}

export default ClientForm



// WEBPACK FOOTER //
// ./src/components/Clients/ClientForm.jsx